import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MailPlus = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 13V6.778c0-.472-.19-.924-.527-1.257A1.8 1.8 0 0 0 19.2 5H4.8c-.477 0-.935.187-1.273.52A1.77 1.77 0 0 0 3 6.779v10.666c0 .978.81 1.778 1.8 1.778H12m9-11.555-8.073 5.066a1.76 1.76 0 0 1-1.854 0L3 7.667m15.3 8V21m-2.7-2.667H21"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MailPlus) as SvgIcon;
export { ForwardRef as ReactComponent };
